import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import AppLayout from '../components/AppLayout';

export default function LiveAuthCallback() {
  const [searchParams]  = useSearchParams();
  const navigate        = useNavigate();
  const [status, setStatus] = useState('exchanging'); // exchanging | success | error
  const [error, setError]   = useState('');

  useEffect(() => {
    const requestToken = searchParams.get('request_token');
    const loginStatus  = searchParams.get('status');

    if (loginStatus === 'error' || !requestToken) {
      setStatus('error');
      setError(searchParams.get('message') || 'Zerodha login failed or was cancelled');
      return;
    }

    api.get(`/live/auth/callback?request_token=${requestToken}`)
      .then(() => {
        setStatus('success');
        setTimeout(() => navigate('/live'), 1500);
      })
      .catch(err => {
        setStatus('error');
        setError(err.response?.data?.error || 'Token exchange failed');
      });
  }, [searchParams, navigate]);

  return (
    <AppLayout>
      <div className="p-12 text-center flex flex-col items-center gap-3">
        {status === 'exchanging' && (
          <>
            <div className="text-lg text-foreground">Connecting to Zerodha…</div>
            <div className="text-sm text-muted-foreground">Exchanging token, please wait.</div>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-lg text-win">Connected!</div>
            <div className="text-sm text-muted-foreground">Redirecting back to Live Trading…</div>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-lg text-destructive">Authentication failed</div>
            <div className="text-sm text-muted-foreground">{error}</div>
            <button className="text-sm text-primary hover:underline" onClick={() => navigate('/live')}>← Back to Live Trading</button>
          </>
        )}
      </div>
    </AppLayout>
  );
}
